import { AbstractControl, ValidationErrors } from '@angular/forms';

export function ItalianTaxCodeValidator(control: AbstractControl): ValidationErrors | null {
  const cf = control.value?.toUpperCase();
  if (!cf) return null;

  const regex = /^[A-Z]{6}[0-9]{2}[A-EHLMPR-T]{1}[0-9]{2}[A-Z]{1}[0-9]{3}[A-Z]{1}$/;

  if (!regex.test(cf)) {
    return { invalidTaxCode: true };
  }


  return null;
}
